import "@mantine/core/styles.css"
import "@civala/shared-ui/styles/pitch-global.css"
import "./portal.css"

import { pitchAppTheme } from "@civala/shared-ui"
import { MantineProvider } from "@mantine/core"
import { createRouter, RouterProvider } from "@tanstack/react-router"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { routeTree } from "./routeTree.gen"

// defaultViewTransition matches nexus/invest/investor: TanStack drives the
// View Transitions API on navigation, and AppShellLayout's viewTransitionName
// ("portal-content") names the element that cross-fades.
const router = createRouter({
  routeTree,
  defaultViewTransition: true,
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MantineProvider theme={pitchAppTheme} defaultColorScheme="light">
      <RouterProvider router={router} />
    </MantineProvider>
  </StrictMode>,
)
